import { defineMessages } from 'react-intl';

export default defineMessages({
    topupEligibleAlertTitle: {
        id: '_.outstanding_view.topupEligibleAlertTitle',
        defaultMessage: 'Great news, you can now request more funds -'
    },
    topupEligibleAlertSubtitle: {
        id: '_.outstanding_view.topupEligibleAlertSubtitle',
        defaultMessage:
            'you can choose whether to go ahead once you have received an offer'
    },
    applyNowCTAText: {
        id: '_.outstanding_view.applyNowCTAText',
        defaultMessage: 'Apply Now'
    },
    notYetTopupEligilbeAlertText: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertText',
        defaultMessage:
            "You can request more funds once you've repaid {amount} -"
    },
    notYetTopupEligilbeAlertDescription: {
        id: '_.outstanding_view.notYetTopupEligilbeAlertDescription',
        defaultMessage:
            "You've passed our eligibility checks but your approval will still be subject to a credit review"
    },
    interestOnlyExtendTitle: {
        id: '_.outstanding_view.interestOnlyExtendTitle',
        defaultMessage: 'You can extend your interest-only period by 3 months'
    },
    interestOnlyExtendCta: {
        id: '_.outstanding_view.interestOnlyExtendCta',
        defaultMessage: 'Extend my interest-only period'
    },
    interestOnlyExtensionDescription: {
        id: '_.outstanding_view.interestOnlyExtenionDescription',
        defaultMessage:
            'You can extend your interest-only period by 3 months keeping your interest rate at {interestRate} per month before {timeoutDate}'
    },
    interestOnlyExtensionWithFundsDescription: {
        id: '_.outstanding_view.interestOnlyExtenionWithFundsDescription',
        defaultMessage:
            'You can extend your interest-only period by 3 months and draw down up to {amount} with an interest rate of {interestRate} per month before {timeoutDate}'
    },
    approvedTitle: {
        id: '_.outstanding_view.topupApprovedTitle',
        defaultMessage: "You're approved!"
    },
    approvedDescription: {
        id: '_.outstanding_view.topupApprovedDescription',
        defaultMessage:
            'You can drawdown up to {amount} at a rate of {interestRate} before {expiryDate}'
    },
    accessfundsCTAText: {
        id: '_.outstanding_view.accessfundsCTAText',
        defaultMessage: 'Access funds'
    }
});
